import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Observable} from 'rxjs';
import Grid from '@material-ui/core/Grid';
import Switch from '@material-ui/core/Switch';

export class Toggle extends Component {
    static get propTypes() {
        return {
            children: PropTypes.string.isRequired,
            handleChange$: PropTypes.instanceOf(Observable).isRequired,
        };
    }

    constructor(props) {
        super(props);
        this.state = {checked: false};
        this.handleChange = this.handleChange.bind(this);
    }


    handleChange(evt) {
        this.setState({checked: evt.target.checked});
        this.props.handleChange$.next(evt.target.checked);
    }

    render() {
        return (
            <Grid container>
                <Grid item xs={10}>
                    <label>{this.props.children}</label>
                </Grid>
                <Grid item xs={2}>
                    <Switch checked={this.state.checked} onChange={this.handleChange}/>
                </Grid>
            </Grid>
        );
    }
}
